import React from "react";
import { Card } from "collections/Cards";
import { PRIVACY_LINK, STATUS_LINK, TOS_LINK } from "Constants";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import "./About.scss";
import lensLogo from "assets/images/poly_logo_lens.svg";
import { PolyLogoFooter } from "elements";

const About: React.FC = () => {
  const { t } = useTranslation();
  const { Content } = Layout;

  return (
    <Layout>
      <Content className="about pr-0">
        <h2 className="about-title page-title text-center">About</h2>
        <Card className="about-card text-center">
          <div className="brand pb-5">
            <img src={lensLogo} alt="Poly Lens" data-testid="logo" />
          </div>
          <p className="plt-copyright">
            {t("COPYRIGHT", { year: new Date().getFullYear() })}
          </p>
          <p>
            <a target="_blank" rel="noopener noreferrer" href={TOS_LINK}>
              {t("TOS")}
            </a>
          </p>
          <p>
            <a target="_blank" rel="noopener noreferrer" href={PRIVACY_LINK}>
              {t("PRIVACY")}
            </a>
          </p>
          <p>
            <a target="_blank" rel="noopener noreferrer" href={STATUS_LINK}>
              {t("SERVICE_STATUS")}
            </a>
          </p>
        </Card>
      </Content>
      <PolyLogoFooter />
    </Layout>
  );
};

export default About;
